export const RENT_PAYMENT_METHODS = {
  STANDING_ORDER: 0,
  DEDUCT_FROM_TAKINGS: 1,
  INVOICE: 2,
} as const;

export type RentPaymentMethod = typeof RENT_PAYMENT_METHODS[keyof typeof RENT_PAYMENT_METHODS];
